<template>
    <button class="button secondary" :class="{TA: isTestAchat}" @click="$emit('click')" ref="button">
    {{ $t("previous") }}
    </button>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters("common", ["isTestAchat"])
    },
    mounted(){
        if(this.isTestAchat) this.$refs.button.style.fontFamily = "Lato";
    }
}
</script>


// WEBPACK FOOTER //
// src/components/PreviousButton.vue